const DATE_FORMAT = "MM/yyyy";

const POPPER_OFFSET = 15;

const INITIAL_ICON_SIZE = 24;

export { DATE_FORMAT, POPPER_OFFSET, INITIAL_ICON_SIZE };
